var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.00200009C14.0595 0.00200009 13.5 0.562 13.5 1.252C13.5 1.394 13.529 1.5275 13.572 1.6545L10.525 4.278C10.3115 4.1075 10.0445 4.0015 9.75 4.0015C9.41 4.0015 9.103 4.138 8.878 4.358L6.491 3.163C6.4445 2.515 5.91 2.0015 5.25 2.0015C4.56 2.0015 4 2.5615 4 3.2515C4 3.4405 4.045 3.6175 4.12 3.778L1.6865 6.584C1.55 6.533 1.4045 6.501 1.25 6.501C0.5595 6.501 0 7.0605 0 7.751C0 8.4415 0.5595 9.001 1.25 9.001C1.9405 9.001 2.5 8.4415 2.5 7.751C2.5 7.585 2.466 7.4265 2.407 7.2815L4.88 4.439C4.998 4.4755 5.12 4.501 5.25 4.501C5.6135 4.501 5.9385 4.343 6.167 4.0945L8.5015 5.265C8.51 5.9485 9.065 6.5005 9.75 6.5005C10.4405 6.5005 11 5.941 11 5.2505C11 5.2285 10.9945 5.2075 10.9935 5.1855L14.245 2.392C14.3995 2.4605 14.5695 2.5 14.75 2.5C15.4405 2.5 16 1.9405 16 1.25C16 0.5595 15.4405 0 14.75 0V0.00200009Z",
    fill: "#E44A77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.1e5ab8f102c5992b30922af1b2904629.svg";
export { ForwardRef as ReactComponent };